import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import remoteImg from '@/components/common/remoteImg';
import { getToken } from '@/utils/auth'; // get token from cookie

export default {
  props: {
    ifAddEdit: {
      type: Boolean,
      default: false
    },
    AddformData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isresource: {
      type: String,
      default: ''
    },
    systemdata: null,
    isaddresource: {
      type: Boolean,
      default: false
    },
    iseditfatherresource: {
      type: Boolean,
      default: false
    }
  },
  components: {
    remoteImg: remoteImg
  },
  data: function data() {
    return {
      formPower: {
        directoryResource: 'FALSE',
        isSystemNode: 'FALSE',
        isAllowOpenPage: 0
      },
      formPowerdefault: {},
      fathername: '',
      systemname: '',
      IsInterface: true,
      IsLastMenu: false,
      IsMobile: false,
      roleRules: {
        resourceType: [{
          required: true,
          message: '请选择资源类型',
          trigger: ['blur', 'change']
        }],
        resourceId: [{
          required: true,
          message: '请输入资源编号',
          trigger: 'blur'
        }],
        resourceName: [{
          required: true,
          message: '请输入资源名称',
          trigger: 'blur'
        }],
        systemId: [{
          required: true,
          message: '请选择系统名称',
          trigger: 'change'
        }],
        path: [{
          required: true,
          message: '请输入资源路径',
          trigger: 'blur'
        }],
        directoryResource: [{
          required: true,
          message: '请选择目录类型',
          trigger: 'change'
        }],
        isSystemNode: [{
          required: true,
          message: '请选择节点类型',
          trigger: 'change'
        }]
      },
      imgSrc: '',
      funcIcon: '',
      resquestheard: {
        Authorization: "bearer ".concat(getToken())
      },
      pubilcSystem: []
    };
  },
  watch: {
    formPower: {
      handler: function handler(newVal) {
        if (newVal.resourceType === 'INTERFACE') {
          this.IsInterface = true;
        } else {
          this.IsInterface = false;
        }
        if (newVal.resourceType === 'MOBILE') {
          this.IsMobile = true;
        } else {
          this.IsMobile = false;
        }
        if (newVal.resourceType === undefined) {
          this.IsInterface = true;
        }
        if (newVal.directoryResource === 'FALSE') {
          this.IsLastMenu = true;
        } else {
          this.IsLastMenu = false;
        }
      },
      deep: true
    },
    resform: {
      handler: function handler(newVal, oldVal) {
        if (newVal.resourceType === 'RESOURCE' && newVal.directoryResource === 'FALSE' && (newVal.systemId !== oldVal.systemId || newVal.systemId)) {
          this.setpublicsystem();
        }
        if (newVal.resourceType === 'MOBILE' && newVal.isSystemNode === 'FALSE' && newVal.systemId !== oldVal.systemId) {
          this.setpublicsystem();
        }
        if (newVal.resourceType !== oldVal.resourceType && newVal.isSystemNode === 'FALSE' && newVal.systemId) {
          this.setpublicsystem();
        }
      },
      deep: true
    }
  },
  created: function created() {
    if (this.ifAddEdit) {
      delete this.systemdata.children;
      this.formPower = this.systemdata;
      this.funcIcon = '';
      this.imgSrc = '';
      if (this.formPower.icon !== null && this.formPower.icon !== undefined) {
        this.imgSrc = this.systemdata.icon;
      } else {
        this.formPower.icon = '';
      }
      if (this.formPower.functionIcon !== null && this.formPower.functionIcon !== undefined) {
        this.funcIcon = this.systemdata.functionIcon;
      } else {
        this.formPower.funcIcon = '';
      }
    } else {
      this.formPower = this.formPowerdefault;
      if (this.isaddresource) {
        this.formPower.resourceType = this.isresource;
        this.fathername = this.systemdata.resourceName;
        // this.formPower.systemId = this.systemdata.systemId;
      }
    }
    // this.formPower = this.AddformData;
  },

  methods: {
    setpublicsystem: function setpublicsystem() {
      var _this = this;
      var sys = '';
      if (this.formPower.resourceType === 'RESOURCE') {
        sys = 'PC_WEB';
      } else if (this.formPower.resourceType === 'MOBILE') {
        sys = 'MOBILE_WEB';
      }
      this.$API.getRequest({
        url: "/platform/systemInner/publicSystemList?systemId=".concat(this.formPower.systemId, "&systemType=").concat(sys)
      }).then(function (res) {
        _this.pubilcSystem = res.result;
        if (!_this.formPower.jumpSystemId) {
          _this.formPower.jumpSystemId = _this.formPower.systemId;
        }
      });
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === 'image/svg+xml';
      var isLt2M = file.size / 1024 < 100;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 SVG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 100KB!');
      }
      return isJPG && isLt2M;
    },
    imgSuccess: function imgSuccess(response) {
      this.imgSrc = response.result && response.result.split('/')[2];
      this.formPower.iconPath = response.result;
    },
    funcImgSuccess: function funcImgSuccess(response) {
      this.funcIcon = response.result && response.result.split('/')[2];
      this.formPower.functionIconPath = response.result;
    },
    cancelDailog: function cancelDailog() {
      this.$emit('ResourceAddSubmit', {
        bool: false
      });
    },
    commit: function commit() {
      var _this2 = this;
      if (!this.ifAddEdit) {
        delete this.formPower.resourceStatus;
      }
      this.$refs.formPower.validate(function (valid) {
        if (valid) {
          _this2.$emit('ResourceAddSubmit', {
            bool: true,
            formData: _this2.formPower
          });
        } else {
          _this2.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    }
  },
  computed: {
    prePath: function prePath() {
      var _this3 = this;
      var sys = '';
      var baseUrl = '';
      if (this.formPower.resourceType === 'RESOURCE') {
        sys = 'PC_WEB';
      } else if (this.formPower.resourceType === 'MOBILE') {
        sys = 'MOBILE_WEB';
      } else {
        sys = '';
      }
      this.AddformData[0].selectData.forEach(function (ele) {
        if (_this3.formPower.systemId === ele.systemId) {
          ele.systemCategory && ele.systemCategory.forEach(function (child) {
            if (child.systemType === sys) {
              baseUrl = child.baseUrl;
            }
          });
        }
      });
      return baseUrl;
    },
    resform: function resform() {
      return JSON.parse(JSON.stringify(this.formPower));
    }
  }
};